import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-email-fields',
    templateUrl: './email-fields.component.html',
    styleUrls: ['./email-fields.component.scss'],
})
export class TableEmailFieldsComponent implements OnInit {

    @Input('data') config;

    // Cada template de email guarda o assunto/corpo em campos `{prefix}_Subject` / `{prefix}_Body`
    templates = [
        { label: 'Novo Feedback', prefix: 'NewFeedback' },
        { label: 'Cópia de Submissão de Comerciante', prefix: 'MerchantApplicationCopy' },
        { label: 'Alteração de Estado da Candidatura', prefix: 'MerchantApplicationStatusChanged' },
        { label: 'Nova Submissão de Candidatura', prefix: 'NewMerchantApplicationSubmission' },
        { label: 'Definir Password do Utilizador', prefix: 'DefineUserPassword' },
        { label: 'Novo Registo de Utilizador', prefix: 'NewUserRegist' },
        { label: 'Pedido de Código de Validação', prefix: 'UserValidationCodeRequest' },
        { label: 'Validação Automática de Utilizador', prefix: 'UserAutomaticValidation' },
        { label: 'Emissão de Cartão da Carteira', prefix: 'IssueWalletCard' },
        { label: 'Nova Notificação', prefix: 'NewNotification' },
    ];

    constructor() { }

    ngOnInit() { }

}
